export function triggerHandler<TFunc extends (...args: any[]) => any>(handler: null | undefined, ...params: Parameters<TFunc>): void
export function triggerHandler<TFunc extends (...args: any[]) => any>(handler: TFunc, ...params: Parameters<TFunc>): ReturnType<TFunc>
export function triggerHandler<TFunc extends (...args: any[]) => any>(handler: TFunc | null | undefined, ...params: Parameters<TFunc>): ReturnType<TFunc> | undefined
    export function triggerHandler<TFunc extends (...args: any[]) => any>(handler: TFunc | null | undefined, ...params: Parameters<TFunc>): ReturnType<TFunc> | undefined {
    if (handler) {
        return handler(...params);
    }
}

type EventHandler<T extends any[]> = (...args: T) => void;

export class Event<TArgs extends any[] = any[]> {
    handlers: EventHandler<TArgs>[] = [];

    constructor() {
        this.handlers = [];
    }

    addHandler(handler: EventHandler<TArgs>) {
        if (typeof handler !== 'function') {
            throw new Error('handler must be a function');
        }

        this.handlers.push(handler);
    }

    removeHandler(handler: EventHandler<TArgs>) {
        this.handlers = this.handlers.filter((x) => x !== handler);
    }

    clear() {
        this.handlers = [];
    }

    trigger(...args: TArgs) {
        this.handlers.forEach((handler) => {
            handler(...args);
        });
    }
}